import GameModel from '../../../../vendor_core/core/src/model/GameModel';
import SpinModel from '../../../../vendor_core/core/src/model/SpinModel';
import { HasBigWinCondition } from '../../../../vendor_core/core/src/states/conditions/HasBigWinCondition';

export class CRCHasBigWinCondition extends HasBigWinCondition {
  public check(): boolean {

      return this.hasSpecBigWin();

  }

  private hasSpecBigWin(): boolean {

      return SpinModel.getWinRatio() >= (GameModel.gameConfig as any).bigWinRatioLevels[0];

  }

}
